import React from "react";
import "./Home.css";
import mobileImage from "../../assets/images/mobileImage.png";
import googleplay from "../../assets/images/googleplay.png";
import appstore from "../../assets/images/appstore.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function AppShowcase({ homeSettings = {} }) {
  const subtitle =
    homeSettings.home_app_subtitle &&
    homeSettings.home_app_subtitle.trim() !== ""
      ? homeSettings.home_app_subtitle
      : "Download the CaresAtHome App";
  const title =
    homeSettings.home_app_title && homeSettings.home_app_title.trim() !== ""
      ? homeSettings.home_app_title
      : "Smart Healthcare Services at Your Fingertips";
  const description =
    homeSettings.home_app_description &&
    homeSettings.home_app_description.trim() !== ""
      ? homeSettings.home_app_description
      : "Book caregiver services, doctor consultations, diagnostics, ICU setup, emergency care, and medical support anytime, anywhere with the CaresAtHome app.";

  return (
    <div className="app_show">
      <div className="container-fluid">
        <div className="showcase-outer">
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="showcase-content">
                <label htmlFor="">{subtitle}</label>
                <h4>{title}</h4>
                <p>{description}</p>
                <ul className="p-0">
                  <li>
                    <CheckCircleIcon /> Easy Service Booking
                  </li>
                  <li>
                    <CheckCircleIcon /> Verified Caregivers & Doctors
                  </li>
                  <li>
                    <CheckCircleIcon /> Home Nursing & ICU Care
                  </li>
                  <li>
                    <CheckCircleIcon /> 24/7 Healthcare Support
                  </li>
                </ul>
                <div className="plystore-links">
                  <a
                    href="https://play.google.com/store/search?q=Caresathome&c=apps&hl=en_IN"
                    target="_blank"
                  >
                    <img src={googleplay} alt="" className="img-fluid" />
                  </a>
                  <a
                    href="https://play.google.com/store/search?q=Caresathome&c=apps&hl=en_IN"
                    target="_blank"
                  >
                    <img src={appstore} alt="" className="img-fluid" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="app-img text-center">
                <img src={mobileImage} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppShowcase;
